<template>
  <div class="login-modal-content rounded overflow-hidden">
    <div class="card bg-dark text-white border-0">
      <div class="card-body p-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="card-title m-0 text-warning">Rejestracja</h3>
          <button type="button" class="btn-close btn-close-white" @click="$emit('close')"></button>
        </div>
        <form @submit.prevent="handleRegister" v-if="!successMessage">
          <div class="mb-3">
            <label for="email" class="form-label"><font-awesome-icon icon="fa-envelope"/> Email</label>
            <input
                type="email"
                class="form-control bg-dark text-white border-secondary"
                id="email"
                v-model="email"
                required
                placeholder="twoj@email.pl"
            >
          </div>
          <div class="mb-3">
            <label for="password" class="form-label"><font-awesome-icon icon="fa-key"/> Hasło</label>
            <input
                type="password"
                class="form-control bg-dark text-white border-secondary"
                id="password"
                v-model="password"
                required
                placeholder="hasło"
            >
          </div>
          <div class="mb-3">
            <label for="passwordConfirm" class="form-label"><font-awesome-icon icon="fa-key"/> Powtórz hasło</label>
            <input
                type="password"
                class="form-control bg-dark text-white border-secondary"
                id="passwordConfirm"
                v-model="passwordConfirm"
                required
                placeholder="powtórz hasło"
            >
          </div>
          <div class="mb-3">
            <label>
              <input type="checkbox" v-model="rulesAccepted"/>
              Akceptuję <router-link to="/regulamin" target="_blank">Regulamin</router-link> oraz <router-link to="/polityka-prywatnosci" target="_blank">Politykę Prywatności</router-link>
            </label>
          </div>

          <div class="mb-3">
            <BotCheckSelect v-model="bcheck"/>
          </div>

          <div v-if="errorMessage" class="alert alert-danger py-2">
            {{ errorMessage }}
          </div>

          <div class="d-grid mt-4">
            <button
                type="submit"
                class="btn btn-warning fw-bold"
                :disabled="isLoading"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              Zarejestruj się
            </button>
          </div>
          <div v-if="!authStore.user" class="text-center mt-3">
            <a href="#" class="nav-link" @click="$emit('close')">
              <font-awesome-icon icon="fa-sign-in"/>
              Zaloguj się
            </a>
          </div>
        </form>
        <div v-else class="alert alert-info py-2">
          {{ successMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useAuthStore} from '@/stores/auth'
import {fetchWrapper} from '@/wrappers/api/fetchWrapper'
import {ref} from "vue";
import BotCheckSelect from "@/components/user/BotCheckSelect.vue";

export default {
  name: "SignupPage",
  components: {BotCheckSelect},
  emits: ['close'],
  setup() {
    const authStore = useAuthStore();
    return {authStore};
  },
  data() {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      rulesAccepted: ref(false),
      errorMessage: '',
      successMessage: '',
      isLoading: false,
      bcheck: null,
    }
  },
  methods: {
    async handleRegister() {
      // const authStore = useAuthStore();
      this.isLoading = true;
      this.errorMessage = '';

      if (this.password !== this.passwordConfirm) {
        this.isLoading = false;
        this.errorMessage = "Powtórzone hasło jest niepoprawne!"
        return
      }

      let minPassLength = 6
      if (this.password.length < minPassLength) {
        this.isLoading = false;
        this.errorMessage = "Hasło musi zawierać minimum "+minPassLength+" znaków!"
        return
      }

      if (!this.rulesAccepted) {
        this.isLoading = false;
        this.errorMessage = "Nie zaakceptowano regulaminu!"
        return
      }

      if (!this.bcheck) {
        this.isLoading = false;
        this.errorMessage = "Nie zatwierdzono captcha!"
        return
      }

      try {
        const response = await fetchWrapper.post('/signup', {
          email: this.email,
          password: this.password,
          bcheck: this.bcheck
        });


        if (response.message) {
          this.successMessage = "Link aktywacyjny wysłano na podany email! Konto musi zostać aktywowane przed zalogowaniem!";
        }

        // Delay closing the login modal by 2 seconds
        setTimeout(() => {
          this.$emit('close');
        }, 5000);
        this.$router.push('/');
      } catch (err) {
        this.errorMessage = "Rejestracja nie powiodła się! Sprawdź poprawność danych!";
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  backdrop-filter: blur(5px);
}

.login-modal-content {
  width: 100%;
  max-width: 400px;
  animation: modal-appear 0.3s ease-out;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.form-control:focus {
  background-color: #212529;
  color: white;
  border-color: #f0c040;
  box-shadow: 0 0 0 0.25rem rgba(240, 192, 64, 0.25);
}

.btn-warning {
  background-color: #f0c040;
  border-color: #f0c040;
}

.btn-warning:hover {
  background-color: #ffd966;
  border-color: #ffd966;
}
</style>